// @ts-nocheck
import classNames from 'clsx'
import { string } from 'prop-types'

import { isMobile } from 'shared/utils/deviceClassUtils'
import { InferPropsWithDefaults } from 'shared/utils/propTypes'
import { usePublicConfig } from 'views/utils/shopAndRuntimeConfigUtils'

import { PLACEHOLDER_SIZES_BY_ID } from './consts'

const AdSlotPlaceholderPropTypes = {
  slotId: string.isRequired,
  className: string,
}

const AdSlotPlaceholderDefaultPropTypes = {
  className: null,
}

type AdSlotPlaceholderProps = InferPropsWithDefaults<
  typeof AdSlotPlaceholderPropTypes,
  typeof AdSlotPlaceholderDefaultPropTypes
>

const AdSlotPlaceholder = ({ slotId, className }: AdSlotPlaceholderProps) => {
  const sizes = PLACEHOLDER_SIZES_BY_ID[slotId]

  if (!sizes) {
    return null
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks -- TODO This function uses a hook, so is also a hook and should be renamed to `use…`
  const { deviceClass } = usePublicConfig()

  const { width, height } =
    sizes[isMobile(deviceClass) ? 'small' : 'large'] || {}

  if (!height) {
    return null
  }

  // Note that this is not responsive on purpose (height does not scale
  // with width), since banners themself are not responsive (yet).

  const classes = classNames(
    'max100width-image u-background-color--greyLight-light',
    className
  )

  return (
    <div
      data-clientside-hook="adSlotPlaceholder"
      className={classes}
      style={{
        width: `${width}px`,
        height: `${height}px`,
      }}
    />
  )
}

AdSlotPlaceholder.propTypes = AdSlotPlaceholderPropTypes
AdSlotPlaceholder.defaultProps = AdSlotPlaceholderDefaultPropTypes

export default AdSlotPlaceholder
